/** React context for focus/timer state shared across task views. */
// @ts-check
import { createContext } from 'react';

/** @type {import('react').Context<{ activeFocusTaskId: string|null, focusStartTime: number|null, startFocus: (taskId: string) => void, stopFocus: () => void }|null>} */
export const FocusContext = createContext(null);
